module.exports = {"513422100":"乔瓦镇","513422101":"瓦厂镇","513422102":"茶布朗镇","513422103":"雅砻江镇","513422104":"水洛镇","513422105":"列瓦镇","513422201":"博科乡","513422202":"宁朗乡","513422203":"依吉乡","513422204":"俄亚纳西族乡","513422206":"牦牛坪乡","513422207":"屋脚蒙古族乡","513422208":"项脚蒙古族乡","513422209":"李子坪乡","513422213":"西秋乡","513422214":"克尔乡","513422215":"白碉苗族乡","513422216":"三桷桠乡","513422217":"倮波乡","513422218":"卡拉乡","513422219":"后所乡","513422220":"沙湾乡","513422222":"固增苗族乡","513422223":"麦日乡","513422224":"东朗乡","513422225":"唐央乡","513422226":"博窝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513422.json
// module id = 2563
// module chunks = 0